/******************
 * Media queries: use these in your scripts, based on scss breakpoints
 * Usage ex1:
		if (media.default.matches) {
			//screen is bigger then 1100px
		}
	* Usage ex2:
		const paragraph = document.querySelector('p')

		function makeBlueOnDesktop(e) {
			if (e.matches) {
				//media query matches, make paragraph blue
				paragraph.style.color = 'blue'
			}
			else {
				//media query does not match, remove blue coloring
				paragraph.style.color = ''
			}
		}

		media.default.addListener(makeBlueOnDesktop)
******************/
const doc = getComputedStyle(document.documentElement);
let media;

if (!!window.CSS && !!CSS.supports('color', 'var(--fake-var)')) {
	media = {
		xs: window.matchMedia(`(min-width: ${doc.getPropertyValue('--breakXs')})`),
		sm: window.matchMedia(`(min-width: ${doc.getPropertyValue('--breakSm')})`),
		md: window.matchMedia(`(min-width: ${doc.getPropertyValue('--breakMd')})`),
		lg: window.matchMedia(`(min-width: ${doc.getPropertyValue('--breakLg')})`),
		xl: window.matchMedia(`(min-width: ${doc.getPropertyValue('--breakXl')})`),
	};
} else {
	media = {
		xs: window.matchMedia('(min-width: 0)'),
		sm: window.matchMedia('(min-width: 576px)'),
		md: window.matchMedia('(min-width: 768px)'),
		lg: window.matchMedia('(min-width: 992px)'),
		xl: window.matchMedia('(min-width: 1200px)'),
	};
}

export default media;
